import React, {useState} from 'react'
import {Container, Row, Col, Nav} from 'react-bootstrap'
import {DirectDialView} from '../direct-dial/DirectDialView'
import {RequesterQuickDialView} from '../requester-quick-dial/RequesterQuickDialView'
import {UnfilledAssignmentEmailSettings} from '../../configuration-management/components/UnfilledAssignmentEmailSettings'
import {MfaSettingsPanel} from '../../configuration-management/components/mfa/MfaSettingsPanel'

type SidebarKey = 'direct-dial' | 'quick-dial' | 'unfilled-assignment' | 'mfa'

type RequesterSettingsProps = {
  userId: string
  customerCode?: string | number
}

export function RequesterSettings({userId, customerCode}: RequesterSettingsProps) {
  const [active, setActive] = useState<SidebarKey>('direct-dial')

  const sidebarItem = (key: SidebarKey, label: string) => {
    const isActive = active === key
    return (
      <div
        role='button'
        onClick={() => setActive(key)}
        onKeyDown={() => setActive(key)}
        tabIndex={0}
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '14px 16px',
          cursor: 'pointer',
          background: isActive ? '#e53935' : 'transparent',
          color: isActive ? '#fff' : '#333',
          borderRadius: 6,
          marginBottom: 8,
        }}
      >
        <div
          style={{
            width: 6,
            height: '100%',
            background: isActive ? '#b71c1c' : 'transparent',
            borderRadius: '0 3px 3px 0',
            marginRight: 12,
          }}
        />
        <div style={{fontWeight: 600}}>{label}</div>
      </div>
    )
  }

  return (
    <Container fluid className='p-0 pt-5'>
      <Row>
        <Col md={3} lg={3} className='pe-4'>
          <div style={{maxWidth: 320}}>
            <Nav className='flex-column'>
              <Nav.Item>{sidebarItem('direct-dial', 'Direct Dial')}</Nav.Item>
              <Nav.Item>{sidebarItem('quick-dial', 'Quick Dial')}</Nav.Item>
              <Nav.Item>{sidebarItem('unfilled-assignment', 'Unfilled Assignment')}</Nav.Item>
              <Nav.Item>{sidebarItem('mfa', 'Multi Factor Authentication')}</Nav.Item>
            </Nav>
          </div>
        </Col>

        <Col md={9} lg={9}>
          <div style={{background: '#fff', padding: 24, borderRadius: 8, minHeight: 320}}>
            {active === 'direct-dial' && (
              <DirectDialView userId={userId} customerCode={customerCode} />
            )}
            {active === 'quick-dial' && (
              <RequesterQuickDialView userId={userId} customerCode={customerCode} />
            )}
            {active === 'unfilled-assignment' && (
              <UnfilledAssignmentEmailSettings requesterId={userId} />
            )}
            {active === 'mfa' && <MfaSettingsPanel userId={userId} mode='admin' />}
          </div>
        </Col>
      </Row>
    </Container>
  )
}
